import { render, staticRenderFns } from "./SaleData.vue?vue&type=template&id=20fc5d76&"
import script from "./SaleData.vue?vue&type=script&lang=ts&"
export * from "./SaleData.vue?vue&type=script&lang=ts&"
import style0 from "./SaleData.vue?vue&type=style&index=0&id=20fc5d76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports